import u from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function o(t) {
  a(1, arguments);
  var e = u(t), r = e.getMinutes();
  return r;
}
export {
  o as default
};
